/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DashboardPageExportSettings', 'model/DashboardPage', 'model/DashboardPageBlock', 'model/CorporateStructureLink', 'model/DashboardPageReport', 'model/FileTransferHelperEntity'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DashboardPageExportSettings'), require('../model/DashboardPage'), require('../model/DashboardPageBlock'), require('../model/CorporateStructureLink'), require('../model/DashboardPageReport'), require('../model/FileTransferHelperEntity'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DashboardPageExportSettings, root.ForStractionServiceApi.DashboardPage, root.ForStractionServiceApi.DashboardPageBlock, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.DashboardPageReport, root.ForStractionServiceApi.FileTransferHelperEntity);
  }
}(this, function(ApiClient, DashboardPageExportSettings, DashboardPage, DashboardPageBlock, CorporateStructureLink, DashboardPageReport, FileTransferHelperEntity) {
  'use strict';

  /**
   * DashboardPage service.
   * @module api/DashboardPageApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DashboardPageApi. 
   * @alias module:api/DashboardPageApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the dashboardPageAddBusinessReviewPut operation.
     * @callback module:api/DashboardPageApi~dashboardPageAddBusinessReviewPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addBusinessReview
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageExportSettings} body 
     * @param {module:api/DashboardPageApi~dashboardPageAddBusinessReviewPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageAddBusinessReviewPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageAddBusinessReviewPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageAddBusinessReviewPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPage/addBusinessReview', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageAddFromTemplatePut operation.
     * @callback module:api/DashboardPageApi~dashboardPageAddFromTemplatePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} templateID 
     * @param {Integer} groupID 
     * @param {module:api/DashboardPageApi~dashboardPageAddFromTemplatePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageAddFromTemplatePut = function(_4SAPIAppID, body, templateID, groupID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageAddFromTemplatePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageAddFromTemplatePut";
      }

      // verify the required parameter 'templateID' is set
      if (templateID == undefined || templateID == null) {
        throw "Missing the required parameter 'templateID' when calling dashboardPageAddFromTemplatePut";
      }

      // verify the required parameter 'groupID' is set
      if (groupID == undefined || groupID == null) {
        throw "Missing the required parameter 'groupID' when calling dashboardPageAddFromTemplatePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': templateID,
        'groupID': groupID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPage/addFromTemplate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageAddPut operation.
     * @callback module:api/DashboardPageApi~dashboardPageAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPage} body 
     * @param {module:api/DashboardPageApi~dashboardPageAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPage/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageCloneBlockPut operation.
     * @callback module:api/DashboardPageApi~dashboardPageCloneBlockPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * cloneBlock
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlock} body 
     * @param {Integer} sourceBlockID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.targetCompanyID 
     * @param {module:api/DashboardPageApi~dashboardPageCloneBlockPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageCloneBlockPut = function(_4SAPIAppID, body, sourceBlockID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageCloneBlockPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageCloneBlockPut";
      }

      // verify the required parameter 'sourceBlockID' is set
      if (sourceBlockID == undefined || sourceBlockID == null) {
        throw "Missing the required parameter 'sourceBlockID' when calling dashboardPageCloneBlockPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourceBlockID': sourceBlockID,
        'targetCompanyID': opts['targetCompanyID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPage/cloneBlock', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageClonePut operation.
     * @callback module:api/DashboardPageApi~dashboardPageClonePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clone
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPage} body 
     * @param {Integer} sourcePageID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.targetCompanyID 
     * @param {module:api/DashboardPageApi~dashboardPageClonePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageClonePut = function(_4SAPIAppID, body, sourcePageID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageClonePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageClonePut";
      }

      // verify the required parameter 'sourcePageID' is set
      if (sourcePageID == undefined || sourcePageID == null) {
        throw "Missing the required parameter 'sourcePageID' when calling dashboardPageClonePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourcePageID': sourcePageID,
        'targetCompanyID': opts['targetCompanyID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPage/clone', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageCloneWithFiltersPut operation.
     * @callback module:api/DashboardPageApi~dashboardPageCloneWithFiltersPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * cloneWithFilters
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} sourcePageID 
     * @param {String} copiedPageName 
     * @param {module:api/DashboardPageApi~dashboardPageCloneWithFiltersPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageCloneWithFiltersPut = function(_4SAPIAppID, body, sourcePageID, copiedPageName, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageCloneWithFiltersPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageCloneWithFiltersPut";
      }

      // verify the required parameter 'sourcePageID' is set
      if (sourcePageID == undefined || sourcePageID == null) {
        throw "Missing the required parameter 'sourcePageID' when calling dashboardPageCloneWithFiltersPut";
      }

      // verify the required parameter 'copiedPageName' is set
      if (copiedPageName == undefined || copiedPageName == null) {
        throw "Missing the required parameter 'copiedPageName' when calling dashboardPageCloneWithFiltersPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourcePageID': sourcePageID,
        'copiedPageName': copiedPageName
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPage/cloneWithFilters', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageDeleteGet operation.
     * @callback module:api/DashboardPageApi~dashboardPageDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} pageID 
     * @param {module:api/DashboardPageApi~dashboardPageDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageDeleteGet = function(_4SAPIAppID, pageID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageDeleteGet";
      }

      // verify the required parameter 'pageID' is set
      if (pageID == undefined || pageID == null) {
        throw "Missing the required parameter 'pageID' when calling dashboardPageDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageID': pageID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPage/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageEditPut operation.
     * @callback module:api/DashboardPageApi~dashboardPageEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPage} body 
     * @param {module:api/DashboardPageApi~dashboardPageEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPage/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageGenerateBusinessReviewPdfPut operation.
     * @callback module:api/DashboardPageApi~dashboardPageGenerateBusinessReviewPdfPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateBusinessReviewPdf
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageExportSettings} body 
     * @param {module:api/DashboardPageApi~dashboardPageGenerateBusinessReviewPdfPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.dashboardPageGenerateBusinessReviewPdfPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageGenerateBusinessReviewPdfPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageGenerateBusinessReviewPdfPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/DashboardPage/generateBusinessReviewPdf', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageLoadAllGet operation.
     * @callback module:api/DashboardPageApi~dashboardPageLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/DashboardPageReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxBlocksCount  (default to 0)
     * @param {module:api/DashboardPageApi~dashboardPageLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/DashboardPageReport>}
     */
    this.dashboardPageLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxBlocksCount': opts['maxBlocksCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [DashboardPageReport];

      return this.apiClient.callApi(
        '/DashboardPage/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageLoadGet operation.
     * @callback module:api/DashboardPageApi~dashboardPageLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DashboardPageReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} pageID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxBlocksCount  (default to 0)
     * @param {module:api/DashboardPageApi~dashboardPageLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DashboardPageReport}
     */
    this.dashboardPageLoadGet = function(_4SAPIAppID, pageID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageLoadGet";
      }

      // verify the required parameter 'pageID' is set
      if (pageID == undefined || pageID == null) {
        throw "Missing the required parameter 'pageID' when calling dashboardPageLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageID': pageID,
        'maxBlocksCount': opts['maxBlocksCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DashboardPageReport;

      return this.apiClient.callApi(
        '/DashboardPage/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageMovePageBlockToAnotherPageGet operation.
     * @callback module:api/DashboardPageApi~dashboardPageMovePageBlockToAnotherPageGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * movePageBlockToAnotherPage
     * @param {String} _4SAPIAppID 
     * @param {Integer} blockID 
     * @param {Integer} targetPageID 
     * @param {module:api/DashboardPageApi~dashboardPageMovePageBlockToAnotherPageGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageMovePageBlockToAnotherPageGet = function(_4SAPIAppID, blockID, targetPageID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageMovePageBlockToAnotherPageGet";
      }

      // verify the required parameter 'blockID' is set
      if (blockID == undefined || blockID == null) {
        throw "Missing the required parameter 'blockID' when calling dashboardPageMovePageBlockToAnotherPageGet";
      }

      // verify the required parameter 'targetPageID' is set
      if (targetPageID == undefined || targetPageID == null) {
        throw "Missing the required parameter 'targetPageID' when calling dashboardPageMovePageBlockToAnotherPageGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'blockID': blockID,
        'targetPageID': targetPageID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPage/movePageBlockToAnotherPage', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageStoreDashboardPageScreenshotPut operation.
     * @callback module:api/DashboardPageApi~dashboardPageStoreDashboardPageScreenshotPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * storeDashboardPageScreenshot
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} pageID 
     * @param {module:api/DashboardPageApi~dashboardPageStoreDashboardPageScreenshotPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.dashboardPageStoreDashboardPageScreenshotPut = function(_4SAPIAppID, body, pageID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageStoreDashboardPageScreenshotPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageStoreDashboardPageScreenshotPut";
      }

      // verify the required parameter 'pageID' is set
      if (pageID == undefined || pageID == null) {
        throw "Missing the required parameter 'pageID' when calling dashboardPageStoreDashboardPageScreenshotPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageID': pageID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/DashboardPage/storeDashboardPageScreenshot', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
